// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base look (border, radius, focus, error, disabled) comes from
   .cui-control in CustomTheme/customTheme.css. Only input-specific
   tweaks belong here. */

/* Hide number spinners so number inputs match text inputs */
.cif-input[type="number"]::-webkit-outer-spin-button,
.cif-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.cif-input[type="number"] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomInputFields/customInputField.css"],"names":[],"mappings":"AAAA;;wBAEwB;;AAExB,4DAA4D;AAC5D;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Base look (border, radius, focus, error, disabled) comes from\n   .cui-control in CustomTheme/customTheme.css. Only input-specific\n   tweaks belong here. */\n\n/* Hide number spinners so number inputs match text inputs */\n.cif-input[type=\"number\"]::-webkit-outer-spin-button,\n.cif-input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.cif-input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
